import { EXPERIENCES_SERVICE } from "@/services/experiences.service.js";

const state = {
    postExperienceOutput: false,
    getExperiencesOutput: {},
    putExperiencesOutput: false,
    getExperienceByIdOutput: {},
    deleteExperienceByIdOutput: false
};

const actions = {
    //Service to create experience content
    postExperience({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postExperienceRequest');

        EXPERIENCES_SERVICE.postExperience(input)
            .then(
                output => {
                    commit('postExperienceSuccess', output);
                },
                error => {
                    commit('postExperienceFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated experience content
    getExperiences({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getExperiencesRequest');

        EXPERIENCES_SERVICE.getExperiences(queryParams)
            .then(
                output => {
                    commit('getExperiencesSuccess', output);
                },
                error => {
                    commit('getExperiencesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update experience content
    putExperience({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putExperiencesRequest');

        EXPERIENCES_SERVICE.putExperience(input)
            .then(
                output => {
                    commit('putExperiencesSuccess', output);
                },
                error => {
                    commit('putExperiencesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get experience details.
    getExperienceById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getExperienceByIdRequest');

        EXPERIENCES_SERVICE.getExperienceById(id)
            .then(
                output => {
                    commit('getExperienceByIdSuccess', output);
                },
                error => {
                    commit('getExperienceByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete experiences
    deleteExperienceById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteExperienceByIdRequest');

        EXPERIENCES_SERVICE.deleteExperienceById(id)
            .then(
                output => {
                    commit('deleteExperienceByIdSuccess', output);
                },
                error => {
                    commit('deleteExperienceByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }
};

const mutations = {
    //postExperience
    postExperienceRequest(state) {
        state.postExperienceOutput = null;
    },
    postExperienceSuccess(state, output) {
        state.postExperienceOutput = true;
    },
    postExperienceFailure(state) {
        state.postExperienceOutput = false;
    },

    //getExperiences
    getExperiencesRequest(state) {
    },
    getExperiencesSuccess(state, output) {
        state.getExperiencesOutput = output;
    },
    getExperiencesFailure(state) {
        state.getExperiencesOutput = false;
    },

    //putExperience
    putExperiencesRequest(state) {
        state.putExperiencesOutput = null;
    },
    putExperiencesSuccess(state, output) {
        state.putExperiencesOutput = true;
    },
    putExperiencesFailure(state) {
        state.putExperiencesOutput = false;
    },

    //getExperienceById
    getExperienceByIdRequest(state) {
    },
    getExperienceByIdSuccess(state, output) {
        state.getExperienceByIdOutput = output;
    },
    getExperienceByIdFailure(state) {
        state.getExperienceByIdOutput = false;
    },

    //deleteExperienceById
    deleteExperienceByIdRequest(state) {
        state.deleteExperienceByIdOutput = null;
    },
    deleteExperienceByIdSuccess(state, output) {
        state.deleteExperienceByIdOutput = true;
    },
    deleteExperienceByIdFailure(state) {
        state.deleteExperienceByIdOutput = false;
    }
};

export const experiences = {
    namespaced: true,
    state,
    actions,
    mutations
};
